@if (!loaded) {
    <div class="fancy-loader submodule"></div>
}

<div class="standing-data-page" [class.editmode]="standingDataView && standingDataView.editMode">
    @if (loaded && componentConfig) {
        <div class="selection-menu">
            @switch (componentConfig.overviewType) {
                @case (overviewTypes.List) {
                    <standing-data-list-view
                        #standingDataView
                        [standingDataType]="type"
                        [config]="componentConfig"
                        [name]="name"
                        (onDataLoaded)="editCmp.data = $event"
                        (onAdd)="editCmp.add($event)"
                        [changeCallback]="editCmp.edit.bind(editCmp)"
                    >
                    </standing-data-list-view>
                }
                @case (overviewTypes.Tree) {
                    <standing-data-tree-view
                        #standingDataView
                        [standingDataType]="type"
                        [config]="componentConfig"
                        [name]="name"
                        (onDataLoaded)="editCmp.data = $event"
                        (onAdd)="editCmp.add($event)"
                        [changeCallback]="editCmp.edit.bind(editCmp)"
                    >
                    </standing-data-tree-view>
                }
            }
        </div>
    }

    <div class="edit-area">
        <standing-data-editor
            #editCmp
            [config]="componentConfig"
            [type]="type"
            [name]="name"
            (onChange)="standingDataView.loadData($event)"
            (onDetailOpen)="standingDataView.detailOpened($event)"
        ></standing-data-editor>
    </div>
</div>
